<template>
  <div class="container">
    <span>
      <table aria-label="Selector checkbox">
        <tr>
          <th class="hidden"></th>
          <th class="hidden"></th>
        </tr>
        <tr>
          <td><check-item :value="value" v-on:input="onInput" /></td>
          <td><span class="default-label" v-html="label" /></td>
        </tr>
      </table>
    </span>
    <div class="description-container" v-if="description">
      <span v-html="description" />
    </div>
  </div>
</template>

<script>
import CheckItem from "@/components/core/custom/CheckItem";

export default {
  name: "CustomCheckbox",
  components: { CheckItem },
  props: {
    value: Boolean,
    label: String,
    description: String
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style scoped>
.default-label {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #121212;
}

.description-container {
  margin-top: 10px;
  margin-left: 8%;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #121212;
  width: 92%;
  white-space: initial;
}

.hidden {
  display: none;
}
</style>
